import React from 'react';
import { IconContainer } from './IconContainer';

const CancelIcon = (props) => {
    return (
        <IconContainer ariaLabel="cancel" color="rgba(232, 101, 101, 0.6)" hoverColor="var(--sp-error-color)" cursor="pointer" { ...props }>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99999 8.82167L14.125 4.69667L15.3033 5.875L11.1783 10L15.3033 14.125L14.125 15.3033L9.99999 11.1783L5.87499 15.3033L4.69666 14.125L8.82166 10L4.69666 5.875L5.87499 4.69667L9.99999 8.82167Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { CancelIcon };